import { z } from 'zod/v4';
export const TlsClientCertKeyPairSchema = z.object({
    cert: z.string(),
    key: z.string(),
});
//# sourceMappingURL=tlsClientCertKeyPair.js.map